import { scrollTop } from "./modules/scrollTop";

window.addEventListener("DOMContentLoaded", () => {
  scrollTop();
});
